import { createHOC } from "vue-hoc";
import OrgProfile from "./OrgProfile.vue";

import userManagement from '~lib/common/providers/userManagement';
import withUser from "~lib/common/hoc/withUser";

const OrgProfileContainer = createHOC(
  OrgProfile,
  {
    async created() {
      if (!(await userManagement.isKeyOwner())) {
        this.$router.replace({ name: "invite-users" });
        return;
      }
    }
  },
  {}
);

export default withUser()(OrgProfileContainer);
